'use strict'

export default class Symptoms{
    constructor(
        id =null,
        message = "",
        phone = "",
        location = [],
        percentage=0,
        user = null,
        symptoms = [
            {val:"tos",label:"Tos",name:'',value:true},
            {val:"dolor-garganta",label:"Dolor garganta",name:'dolor-garganta',value:false},
            {val:"respiracion-dificil",label:"Respiracion dificil",name:'respiracion-dificil',value:false},
            {val:"congestion-nasal",label:"congestion nasal",name:'congestion-nasal',value:false},
            {val:"fiebre",label:"Fiebre",name:'fiebre',value:false},
        ],
    ) {

        this.id = id
        this.percentage=percentage
        this.message = message
        this.phone = phone
        this.location = location
        this.user = user
        this.symptoms = symptoms
    }

}